import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { notifySomething } from '../_Utils/AppDocuCommon';
import PaperDialogForm from './_PaperDialogForm';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';

export default class AddPaperDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: AddPaperDialog.getInitialItemData(),
    };
  }

  static getInitialItemData() {
    return {
      title: '',
      content: '',
      com_brand: '',
      published: 0,
    };
  }

  addService = async (data) => {
    try {
      const res = await AppDocuServiceCall.createPaper(data);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error adding paper', 'error');
        return;
      }
      await this.props.onItemsChange();
      this.props.onClose();
    } catch (error) {
      console.error('Error adding paper:', error);
      notifySomething('Error adding paper', 'error');
    }
  };

  handleAdd = async () => {
    const m = this.state.itemData || {};
    if (!m.title || !m.title.trim()) {
      notifySomething('Title is required', 'warning');
      return;
    }
    await this.addService({
      title: m.title,
      content: m.content || '',
      com_brand: m.com_brand || null,
      published: m.published || 0,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ itemData: AddPaperDialog.getInitialItemData() });
    }
  }

  render() {
    return (
      <Dialog open={!!this.props.isOpen} onClose={this.props.onClose} maxWidth="md" fullWidth>
        <DialogTitle>Add New Paper</DialogTitle>
        <DialogContent sx={{ overflowY: 'auto' }}>
          <PaperDialogForm
            itemData={this.state.itemData}
            onChange={newData => this.setState({ itemData: newData })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button onClick={this.handleAdd} color="primary">Add</Button>
        </DialogActions>
      </Dialog>
    );
  }
}
